module.exports = __webpack_public_path__ + "media/images/about-31af8863ece02f97682981971c1b50fc.jpg";